import React, { Component } from 'react';
import { connect } from 'react-redux';
import './PaymentSuperFund.css';
import { getWebViewHtml } from '../action/webViewContentAction.js';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';

class WebView extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount(){
    let {dispatch}=this.props;
    let params=this.props.location.state
    dispatch(getWebViewHtml(params, ()=>{this.succallback()}, (msg)=>{this.errcallback(msg)}));
    document.title =this.props.location.state.name
    
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  render(){
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>{this.props.location.state.name}</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content'>
            {
              this.props.location.state.webViewHtml ?
              <iframe ref="iframe" id="postMessage" src={ this.props.location.state.webViewHtml } frameborder="0" width="100%" height={window.screen.height-44} style={{border:0}}></iframe>
              :
              <div style={{fontSize:'0.36rem',padding:13}} dangerouslySetInnerHTML={{__html:
                this.props.location.state.webViewHtml?this.props.location.state.webViewHtml:this.props.webViewHtml
              }} />
            }
          </div>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    webViewHtml:state.webViewHtml
  }
}
export default connect(mapStateToProps)(WebView);



// WEBPACK FOOTER //
// ./src/components/WebView.js